module.exports = __webpack_public_path__ + "img/title-3.8d727fbf.png";